import { useMagicKeys } from "@vueuse/core";
import { computed, onScopeDispose, reactive, ref, watch } from "vue";
import { useUserLocalStorage } from "@/composables/userLocalStorage";
import { defineScopedStore } from "./scopedStore";
export const useWorkflowEditorToolbarStore = defineScopedStore("workflowEditorToolbarStore", () => {
    const snapActive = useUserLocalStorage("workflow-editor-toolbar-snap-active", false);
    const currentTool = ref("pointer");
    const inputCatcherActive = ref(false);
    const inputCatcherEventListeners = new Set();
    const snapDistance = ref(10);
    const toolbarVisible = useUserLocalStorage("workflow-editor-toolbar-visible", true);
    const boxSelectMode = ref("add");
    const boxSelectRect = ref({ x: 0, y: 0, width: 0, height: 0 });
    const commentOptions = reactive({
        bold: false,
        italic: false,
        color: "none",
        textSize: 2,
        lineThickness: 5,
        smoothing: 2,
    });
    const inputCatcherPressed = ref(false);
    function resetBoxSelect() {
        boxSelectRect.value = {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
        };
    }
    function onInputCatcherEvent(type, callback) {
        const listener = {
            type,
            callback,
        };
        inputCatcherEventListeners.add(listener);
        onScopeDispose(() => {
            inputCatcherEventListeners.delete(listener);
        });
    }
    onInputCatcherEvent("pointerdown", () => (inputCatcherPressed.value = true));
    onInputCatcherEvent("pointerup", () => (inputCatcherPressed.value = false));
    onInputCatcherEvent("temporarilyDisabled", () => (inputCatcherPressed.value = false));
    watch(() => inputCatcherActive.value, () => {
        if (!inputCatcherActive.value) {
            inputCatcherPressed.value = false;
        }
    });
    const { shift, space, alt, ctrl } = useMagicKeys();
    const modifierPressed = computed(() => (shift === null || shift === void 0 ? void 0 : shift.value) || (space === null || space === void 0 ? void 0 : space.value) || (alt === null || alt === void 0 ? void 0 : alt.value) || (ctrl === null || ctrl === void 0 ? void 0 : ctrl.value));
    const inputCatcherTemporarilyDisabled = ref(false);
    const inputCatcherEnabled = computed(() => !modifierPressed.value && !inputCatcherTemporarilyDisabled.value);
    function emitInputCatcherEvent(type, event) {
        inputCatcherEventListeners.forEach((listener) => {
            if (listener.type === type) {
                listener.callback(event);
            }
        });
    }
    return {
        toolbarVisible,
        snapActive,
        snapDistance,
        currentTool,
        inputCatcherActive,
        inputCatcherEnabled,
        inputCatcherTemporarilyDisabled,
        commentOptions,
        inputCatcherPressed,
        onInputCatcherEvent,
        emitInputCatcherEvent,
        boxSelectMode,
        boxSelectRect,
        resetBoxSelect,
    };
});
